(() => {
  document.querySelectorAll('[data-rg-hub]').forEach(root => {
    const search=root.querySelector('[data-rg-search]'),select=root.querySelector('[data-rg-filter]');
    const cards=[...root.querySelectorAll('[data-rg-card]')];
    function update(){
      const query=search.value.trim().normalize('NFKC').toLocaleLowerCase();
      let count=0;
      cards.forEach(card=>{
        const match=(select.value==='all'||card.dataset.rgGroup===select.value)&&card.dataset.rgSearchText.normalize('NFKC').toLocaleLowerCase().includes(query);
        card.hidden=!match;if(match)count++;
      });
      root.querySelector('[data-rg-count]').textContent=count;
      root.querySelector('[data-rg-empty]').hidden=count>0;
    }
    search.addEventListener('input',update);select.addEventListener('change',update);update();
  });
})();
